module.exports = __webpack_public_path__ + "static/media/17.cdbe5717.jfif";